import { CountryCodes, Coordinates } from '../types';
import { IsZipCode } from '../validators';

export class AddressValidationSchema {
  street: string;
  houseNumber?: string; // QUESTION: when we remove

  @IsZipCode()
  zipCode: string;

  city: string;
  country: CountryCodes; // TODO: change to countryCode
  coordinates: Coordinates;
}

export class AddressWithOptionalCoordinatesValidationSchema {
  street: string;
  houseNumber?: string; // QUESTION: when we remove

  @IsZipCode()
  zipCode: string;

  city: string;
  country: CountryCodes; // TODO: change to countryCode
  coordinates?: Coordinates;
}
